// The Scheduler page's URL vocabulary — what it keeps about itself in the URL,
// and what OTHER pages use to deep-link into it. `focusTask` is read by
// `useFocusDeepLink`; `openTask` + `tab` by `useTaskUrlSync`. Logistics'
// delivery drawer sends the user to the task a delivery order was raised from.

import type { SchedulerPanelTab } from '@interfaces/IScheduler';

/** `?focusTask=<taskId>` centres the Gantt on that task and flashes it. */
export const FOCUS_TASK_PARAM = 'focusTask';

/** `?openTask=<taskId>` opens that task's drawer once the schedule has loaded,
 *  and STAYS: the Scheduler keeps it in step with the drawer, so the URL is a
 *  shareable link to the task the user is on and survives a refresh. */
export const OPEN_TASK_PARAM = 'openTask';

/** `?tab=<SchedulerPanelTab>` — the drawer tab `openTask` opens on, likewise
 *  kept in step with the tab the user switches to. */
export const PANEL_TAB_PARAM = 'tab';

/** The Scheduler URL for one schedule, centred on a task with its drawer open
 *  on `tab`. */
export function schedulerTaskPath(
  siteId: string,
  scheduleNumber: string,
  taskId: string,
  tab: SchedulerPanelTab,
): string {
  const query = new URLSearchParams({
    [FOCUS_TASK_PARAM]: taskId,
    [OPEN_TASK_PARAM]: taskId,
    [PANEL_TAB_PARAM]: tab,
  });
  return `/scheduler/${encodeURIComponent(siteId)}/${encodeURIComponent(scheduleNumber)}?${query.toString()}`;
}
